import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type ctbvCredType = CarrierLogisticsCredType
export const ctbvDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ctbv: CarrierDef<ctbvCredType> = {
  name: 'The Custom Companies',
  scac: 'ctbv',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'profinder', 'tracking'],
  documentTypes: ctbvDocumentTypes,
}
